export function clearIntervalTimer(timer) {
  if (timer != null) {
    window.clearInterval(timer);
  }
}

//本地存储
function getStorage(key) {
  let localStorage = window.localStorage || false;
  if (!localStorage) {
    return "";
  }
  return localStorage.getItem(key);
}

//获取本地存储值
function setStorage(key, value) {
  let localStorage = window.localStorage || false;
  if (!localStorage) {
    return;
  }
  localStorage.setItem(key, value);
}

//初始化主题属性
export function initThemeData(appData) {
  let themePath = loadThemeCss();
  appData.themePath = themePath;
  return getThemeData(themePath);
}

//更换主题存储
export function changeThemeData(appData, themePath) {
  setStorage("themePath", themePath);
  let themeData = getThemeData(themePath);
  appData.themePath = themeData.themePath;
  appData.themeColor = themeData.themeColor;
  appData.menuBgColor = themeData.menuBgColor;
  appData.menuTextColor = themeData.menuTextColor;
  appData.menuTextActiveColor = themeData.menuTextActiveColor;
}

//加载主题样式文件
function loadThemeCss() {
  let themePath = getStorage("themePath");
  console.log("getStorage themePath === " + themePath);
  if (null == themePath || '' === themePath) {
    themePath = "light";
  }
  let cssFileName = "main.css";
  let includeCss = isIncludeCssLink();
  if (!includeCss) {
    let head = document.getElementsByTagName("head")[0];
    let link = document.createElement("link");
    link.href = "/static/theme/" + themePath + "/css/" + cssFileName;
    link.rel = "stylesheet";
    link.type = "text/css";
    head.appendChild(link);
  } else {
    console.log(":::" + cssFileName + " has include !!!");
  }

  return themePath;
}

//获取主题颜色值
function getThemeData(themePath) {
  if ("light" === themePath) {
    return {
      themePath: themePath,
      themeColor: "#053E99",
      menuBgColor: "#fff",
      menuTextColor: "#303133",
      menuTextActiveColor: "#409EFF"
    };
  } else if ("dark" === themePath) {
    return {
      themePath: themePath,
      themeColor: "#40485b",
      menuBgColor: "#120d22",
      menuTextColor: "#fff",
      menuTextActiveColor: "#0DBED2"
    };
  }
  return "#053E99";
}

//判断样式文件是否已引入
function isIncludeCssLink(name) {
  let es = document.getElementsByTagName('link');
  for (let i = 0; i < es.length; i++)
    if (es[i]['href'].indexOf(name) != -1) {
      return true;
    }
  return false;
}

//设置主区域的边距(驾驶舱为0，其他为5)
export function setMainContentPadding(hasPadding) {
  let px = hasPadding ? 5 : 0;
  $(".main-content").css({
    "left": px + "px",
    "padding": px + ""
  });
}

//导出excel文件
export function exportExcel(methodUrl, params) {
  let interUrl = globalConfig.baseUrl + methodUrl;
  let formData = new FormData();
  if (params != null) {
    for (let key in params) {
      formData.append(key, params[key]);
    }
  }

  let xhr = new XMLHttpRequest();
  xhr.open('post', interUrl);
  xhr.setRequestHeader("token", sessionStorage.getItem('token'));
  xhr.responseType = 'blob';
  xhr.onload = function (e) {
    if (this.status === 200) {
      let blob = this.response;
      let xlsName = "数据报表.xlsx";
      if (params != null && params.fileName != null) {
        xlsName = params.fileName;
      }
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, xlsName);
      } else {
        let downloadElement = document.createElement('a');
        let url = (window.URL) ? window.URL.createObjectURL(blob) : window.webkitURL.createObjectURL(blob);
        downloadElement.href = url;
        downloadElement.download = xlsName;
        document.body.appendChild(downloadElement);
        downloadElement.click();
        window.URL.revokeObjectURL(url);
      }
    }
  };
  xhr.send(formData);
}



// WEBPACK FOOTER //
// ./src/utils/default.js